import { render, staticRenderFns } from "./ed-other-files-viewer.vue?vue&type=template&id=30b7ceee&scoped=true&"
import script from "./ed-other-files-viewer.ts?vue&type=script&lang=js&"
export * from "./ed-other-files-viewer.ts?vue&type=script&lang=js&"
import style0 from "./ed-other-files-viewer.scss?vue&type=style&index=0&id=30b7ceee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7ceee",
  null
  
)

export default component.exports